import React, { FC, useState } from 'react'
import Modal from '../common/Modal'

import '../../assets/scss/first_introduction.scss'

interface IntroModalProps {
  isOpen: boolean
  onCloseModal: () => void
}
const TeamMonthlyIntro: FC<IntroModalProps> = (props) => {
  const { isOpen, onCloseModal } = props
  const initialIntro = {
    show: isOpen,
    currentPage: 0,
  }
  const [intro, setIntro] = useState(initialIntro)

  const handleCloseIntro = () => {
    setIntro({
      show: false,
      currentPage: 0,
    })
    onCloseModal()
  }

  const renderIntroModal1 = () => (
    <>
      <h1 className="intro-title">チームレポートページ(月次・期間選択)の見方</h1>
      <div className="intro-body">
        <div className="intro-description">
          <h3>
            チームレポート(月次・期間選択)ではチームの１ヶ月の作業内容や、チーム全体の傾向を確認できます。
          </h3>
          <h3 className="intro-sample">日付別操作量を表すヒートマップサンプル</h3>
          <img
            alt=""
            src="/static/images/firstIntroduction/team_report/monthly/1.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%', height: '70%' }}
            className="sample-image"
          />
          <h4 className="graph-detail">
            １ヶ月を通しての操作量の推移を表すヒートマップです。
            <br />
            操作量が多いほどタイルの色が濃く表示されており、各タイルをホバーするとその日の操作量を確認できます。
            <br />
            また、タイルをクリックすると該当メンバー、日付の個人レポートページへ遷移します。
          </h4>
        </div>
      </div>
    </>
  )

  return (
    <Modal
      show={isOpen}
      modalSize="large"
      wrapperClass="help"
      closeCallback={handleCloseIntro}
      closeable
    >
      <div className="introduction">
        { intro.currentPage === 0 && renderIntroModal1() }
      </div>
      <button
        type="button"
        className="button complete"
        onClick={handleCloseIntro}
      >
        完了
      </button>
    </Modal>
  )
}

export default TeamMonthlyIntro
